module.exports = __webpack_public_path__ + "2f41aa994f8fb780fad9e05476151b22.jpg";